// 吸附阈值
export const ADSORB_THRESHOLD = 12;

// 支持动态探测的参照物数量上限
export const DYNAMIC_REFERS_LIMIT = 80;

// 吸附线开启状态
export enum EnableSnapLineState {
    DISABLE = '0',
    ENABLE = '1',
}

// 吸附线开关缓存 key
export const ENABLE_SNAP_LINE_STATE_LOCAL_KEY = 'ppt_enable_snap_line_state';

// between间距吸附线的最小的间距剩余空间，如果 refer 与 元素间的剩余空间太小，就没必要产生中间吸附了
export const MIN_BETWEEN_MARGIN_SPACING = 5;

export const MIN_EXTEND_MARGIN_SPACING = 2;
